import React, { useContext, useEffect, useState } from "react";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import MultitabMobile from "../../components/Turnos/MultitabMobile/MultitabMobile";
import RecetaDigitalCard from "../../components/Turnos/RecetaDigital/RecetaDigitalCard";
import { PortalContext } from "../../context/Provider";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import Modal from "../../components/Genericos/Modal/Modal";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import {
  recetasDigitalesReset,
  setReceta,
} from "../../context/Actions/turnos/recetaDigital";
import "./RecetasDigitales.css";
import { displayAyudaMobile } from "../../../global/utils/ayuda";
import { hideAyuda } from "../../context/Actions/ayuda/ayuda";
import Loading from "../../components/Genericos/Loading/Loading";
import camelize from "../../../global/utils/camelize";
import SegundoModal from "../../components/Genericos/SegundoModal/SegundoModal";
import { GlobalContext } from "../../../global/context/Provider";
import { pageContainerVariants } from "global/utils/cardAnimation";
import { motion } from "framer-motion";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";

const RecetasDigitales = () => {
  const {
    modalState,
    segundoModalState,
    recetasDigitalesState,
    recetasDigitalesDispatch,
    ayudaDispatch,
    selectDropDownState,
  } = useContext(PortalContext);

  // Nuevo contexto
  const { authState, toasterDispatch, toasterState } =
    useContext(GlobalContext);

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  let familiarReceta =
    selectDropDownState.selectDropDown.recetaDigital.pacienteElegido.paciente;

  const datosReceta = {
    dni: authState.auth.data.paciente.nro_documento,
    nombre: camelize(authState.auth.data.paciente.nombre),
    telefono: authState.auth.data.paciente.telefono,
    seAtendio: "",
    horario: "",
    nombreMedico: "",
    farmacia: "",
    // nombreFarmaceutico: "",
    // numMatriculaFarmaceutico: "",
  };

  // Función para manejar el click en una pestaña del multitab y redirigir a la ruta correspondiente
  // const onClickMultitabHome = (e) => {
  //   history.push(e.path);
  // };

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };
  useEffect(() => {
    if (recetasDigitalesState.recetasDigitales.data !== null) {
      showToaster(
        {
          texto: "Receta Digital enviada correctamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      recetasDigitalesReset()(recetasDigitalesDispatch);
    }
    //eslint-disable-next-line
  }, [recetasDigitalesState.recetasDigitales.data]);

  useEffect(() => {
    //este time out es porque la libreria no escucha los cambios muy rapido
    setTimeout(() => {
      hideAyuda()(ayudaDispatch);
      displayAyudaMobile("hidden");
    }, 250);
  }, []);

  useEffect(() => {
    setReceta({
      ...datosReceta,
      dni: authState.auth.data.paciente.nro_documento,
      nombre: camelize(authState.auth.data.paciente.nombre),
      telefono: authState.auth.data.paciente.telefono,
    })(recetasDigitalesDispatch);

    // eslint-disable-next-line
  }, [recetasDigitalesState.recetasDigitales.data]);

  useEffect(() => {
    if (selectDropDownState.selectDropDown.recetaDigital.pacienteElegido) {
      setReceta({
        ...datosReceta,
        dni: familiarReceta.nro_documento,
        nombre: camelize(familiarReceta.nombre),
        telefono: familiarReceta.telefono,
      })(recetasDigitalesDispatch);
    } else {
      setReceta({
        ...datosReceta,
        dni: authState.auth.data.paciente.nro_documento,
        nombre: camelize(authState.auth.data.paciente.nombre),
        telefono: authState.auth.data.paciente.telefono,
      })(recetasDigitalesDispatch);
    }
    // eslint-disable-next-line
  }, [selectDropDownState.selectDropDown.recetaDigital.pacienteElegido]);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {segundoModalState.segundoModal.show && <SegundoModal />}
      {toasterState.toaster.show && <ToasterV2 />}
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Recetas Digitales"} />
      <Loading
        dataLoading={recetasDigitalesState.recetasDigitales.loading}
        color="c-white"
        descripcion={
          recetasDigitalesState.recetasDigitales.loading &&
          "Cargando Recetas Digitales..."
        }
      />
      {/* <MultitabMobile posicionMultitab={3} /> */}
      <div className="ptur-bodyContainer-recetaDigital">
        <Sidebar />
        <motion.div
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className="ptur-recetasDigitales-container"
        >
          <p className="rb24b ptur-recetasDigitales-tituloPagina">
            Obtené tu orden médica sin salir de tu casa
          </p>
          <div className="ptur-laboratorio-buscador">
            {/* <MultitabHome tabs={tabsData} onClick={onClickMultitabHome} /> */}
          </div>
          <div className="ptur-recetasDigitales-caja1">
            <RecetaDigitalCard />
          </div>
        </motion.div>
      </div>
    </React.Fragment>
  );
};

export default RecetasDigitales;
